import { useFormik } from 'formik';
import { useMemo } from 'react';
import { useCheckout } from '../../../../../../../hooks/use-checkout';
import { ADYEN_APM_FIELDS, DynamicFieldsAdyen } from '../../../types';
import { validateDynamicForm } from './utils';

export function useDynamicFormAdyen() {
  const { selectedPaymentMethod, checkoutData } = useCheckout();

  const { formFields, formInitialValues } = useMemo(() => {
    const additionalInputFields = selectedPaymentMethod?.additionalInputFields;

    const defaultEmail = checkoutData?.customer?.email || '';

    const formFields = additionalInputFields
      ? (additionalInputFields.flatMap((field) => {
          return [
            {
              apm_key: field.apm_key,
              isRequired: true,
              validation: field.validation,
              defaultValue: field.apm_key === ADYEN_APM_FIELDS.SHOPPER_EMAIL ? defaultEmail : '',
            },
          ];
        }) as DynamicFieldsAdyen[])
      : [];

    const formInitialValues = formFields.reduce(
      (fields, currentField) => ({
        ...fields,
        [currentField.apm_key]: currentField.defaultValue || '',
      }),
      {}
    );
    return {
      formFields,
      formInitialValues,
    };
  }, [selectedPaymentMethod]);

  const formik = useFormik({
    initialValues: formInitialValues,
    validateOnMount: true,
    validateOnBlur: true,
    onSubmit: () => {},
    validate: (values: Record<string, string>) => {
      return validateDynamicForm(values, formFields);
    },
  });

  return { formik, formFields };
}
